import type {
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted_courseProgressState_DegreeLearnerCourseStatesV1_notStartedMember as CourseProgressState,
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted as NotStartedCourse,
} from 'bundles/degree-home/components/v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';

// Filters 'notStarted' courses to find items where is no active session, and there are no enrollable sessions.
export const upcomingCoursesFilterFn = (notStartedCourse: NotStartedCourse) => {
  const progressState = notStartedCourse.courseProgressState as unknown as CourseProgressState;
  return !progressState.notStarted.activeSessionId && !progressState.notStarted.hasEnrollableSession;
};

// Filters 'notStarted' courses to find items where there is no active session, and there are sessions availble to enroll in
export const enrollableCoursesFilterFn = (notStartedCourse: NotStartedCourse) => {
  const progressState = notStartedCourse.courseProgressState as unknown as CourseProgressState;
  return !progressState.notStarted.activeSessionId && progressState.notStarted.hasEnrollableSession;
};
